<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Ações de Recalculo
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <div class="element-inline">
            <form class="d-flex flex-wrap align-items-center" [formGroup]="formFilter">
                <mat-form-field style="min-width:240px">
                    <mat-label>Ação desejada:</mat-label>
                    <mat-select formControlName="tipoRecalculoId">
                        <mat-option *ngFor="let r of tpAcao" [value]="r.id">
                            {{ r.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [hidden]="!tipoRecalculoId || tipoRecalculoId == '2'">
                    <mat-select formControlName="tipoPesagemId" placeholder="Tipo pesagem"
                        [disableControl]="tipoRecalculoId == '2'">
                        <mat-option value="">Todos</mat-option>
                        <mat-option *ngFor="let r of listaTipoPesagem" [value]="r.origemPesoId">
                            {{ r.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-slide-toggle formControlName="tabelaAtiva">Tabela ativa?</mat-slide-toggle> &nbsp; &nbsp;
                <mat-form-field [hidden]="tabelaAtiva">
                    <mat-label>Data referência para tabela:</mat-label>
                    <input matInput autocomplete="off" maskDate [matDatepicker]="dtComparativa"
                        formControlName="dataRef_TabPreco" maskDate [required]="!tabelaAtiva">
                    <mat-datepicker-toggle matSuffix [for]="dtComparativa"></mat-datepicker-toggle>
                    <mat-datepicker #dtComparativa></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Percentual Desconto (%)</mat-label>
                    <input matInput placeholder="Percentual desconto" type="number"
                        formControlName="percentualDesconto" />
                </mat-form-field>
            </form>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <button type="submit" mat-raised-button color="primary" [disabled]="formFilter.invalid"
            (click)="acaoRecalculoFrete()">Recalcular</button>
    </mat-dialog-actions>
</div>